<template>
    <div class="wallet">
        <ActivesCurrencySelect v-if="envName === 'grok' && !add_account_active" />
        <div v-if="add_account_active" class="add_account_wrapper">
            <div class="add_account">
              <div class="body">
                <div class="title">
                  <div class="back-btn__wrapper">
                    <BackBtn @click="add_account_active = false"/>
                  </div>
                  Создание счета
                </div>
                <CurrencySelect v-model="currencyModel" withSearch />
                <div v-if="currencyModel" class="user_data">
                  <div class="user_data_item">
                    <div class="data">E-mail:</div>
                    <div class="value">{{ authInfo.email }}</div>
                  </div>
                  <div class="user_data_item">
                    <div class="data">Телефон</div>
                    <div class="value">{{ authInfo.phone }}</div>
                  </div>
                  <div class="user_data_item">
                    <div class="data">ID пользователя</div>
                    <div class="value">123</div>
                  </div>
                </div>
              </div>
              <BaseButton
                :disabled="!currencyModel"
                @click="saveAccount()"
              >
                <template #label>
                  {{ text('account.create_btn') }}
                </template>
              </BaseButton>
            </div>
        </div>
        <div v-else :class="`account_wrapper ${add_account_active ? 'account_wrapper_mobile' : ''}`">
            <div class="accounts">
                <div
                  v-for="(item, idx) in walletList"
                  class="account"
                  :key="idx"
                  @click="toWallet(item.id)"
                >
                    <div class="currency">{{ item.currency_code }}</div>
                    <div class="amount">{{ getCurrencySymbol(item.currency_code) }} {{ item.balance }}</div>
                </div>
            </div>
        </div>
        <BaseButton
          v-if="!add_account_active"
          @click="addNewAccount()"
          disabled
        >
          <template #label>
            {{ text('account.create_new_btn') }}
          </template>
        </BaseButton>
    </div>
</template>

<script>
import { getCurrencySymbol } from "@/utils/currency.js"
import BaseButton from '@/components/base/buttons/BaseButton.vue'
// import SelectCurrency from '@/components/SelectCurrency.vue'
import CurrencySelect from '@/components/base/selects/CurrencySelect.vue'
import ActivesCurrencySelect from '@/components/base/selects/ActivesCurrencySelect.vue'
import BackBtn from "@/components/base/buttons/BackBtn.vue";

export default {
    name: "Wallet",
    components: {
      ActivesCurrencySelect,
      BaseButton,
      CurrencySelect,
      BackBtn
    },
    data () {
      return {
        currencyModel: null,
        add_account_active: false
      }
    },
    computed: {
      authToken () {
        return this.$store.state.authToken
      },
      walletList () {
        return this.$store.state.walletList
      },
      authInfo () {
        return this.$store.state.authInfo
      },
    },
    created() {
      this.$store.dispatch('refreshWalletList');
    }, 
    methods: {
      getCurrencySymbol,
      addNewAccount () {
        this.add_account_active = true;
      },
      saveAccount () {
        this.add_account_active = false;
        // this.$router.push({name: "WalletSave"})
      },
      toWallet(id) {
        this.$router.push({ name: 'WalletId', params: { id } })
      }
    }
}
</script>

<style lang="scss" scoped>
  .wallet {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px;
  }
  .wallet .add_account_wrapper {
    padding-bottom: 24px;
  }
  .wallet .add_account {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    border-radius: 16px;
    background: var(--layout-bg);
    padding: 24px;

    height: 564px;
  }
  .wallet .add_account .body {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .wallet .add_account .body .title {
    position: relative;

    display: flex;
    justify-content: center;

    color: var(--text-color-primary);
    font-family: "Rubik", sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 135%;
    letter-spacing: 0.4px;
    margin-bottom: 16px;

    .back-btn__wrapper {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .wallet .add_account .body .user_data {
    display: flex;
    flex-direction: column;
    padding: 16px;
    border-radius: 12px;
    gap: 20px;
    background: var(--element-bg);
  }
  .wallet .add_account .body .user_data .user_data_item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .wallet .add_account .body .user_data .user_data_item .data {
    color: #A6A4B4;
    font-family: "Rubik", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 135%;
  }
  .wallet .add_account .body .user_data .user_data_item .value {
    color: #FFF;
    font-family: "Rubik", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 135%;
  }

  .account_wrapper {
    .accounts {
      display: flex;
      flex-direction: column;
      gap: 16px;

      .account {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        cursor: pointer;
        padding: 16px;
        flex-direction: column;
        gap: 8px;
        border-radius: 16px;
        background: var(--element-bg);
        box-shadow: 0 4px 25px 0 rgba(19, 1, 56, 0.07);

        &:hover {
          background: var(--element-bg-lighter);
        }

        .currency {
          color: var(--text-color-primary-reverse);
          font-family: "Rubik", sans-serif;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          background: var(--accent-bg);
          padding: 4px 8px;
          border-radius: 4px;
        }
        .amount {
          color: #FFF;
          font-family: "Rubik", sans-serif;
          font-size: 30px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }
        img {
          position: absolute;
          top: 0;
          right: 0;
          height: 100%;
        }
      }
    }
  }

  @media (max-width: 920px) {
    .wallet .accounts {
      background-color: transparent;
    }
    .wallet .accounts .currency {
      font-size: 12px;
    }
    .wallet .add_account {
      padding: 0;
      background: unset;
      position: relative;
    }
    .wallet .add_account .body .title {
      font-size: 18px;
      letter-spacing: 0.36px;
      margin-bottom: 16px;
    }

    .wallet .add_account .body .user_data {
      background: var(--layout-bg);
    }

    .wallet .account_wrapper_mobile {
      display: none;
    }
    .wallet .add_account_wrapper {
      margin-bottom: 0;
      padding-bottom: 0;
    }
    .walletId {
      margin-bottom: 120px;
    }
  }
</style>